import React from 'react';
import { Table } from '../Table';
import { createTimezonedDate } from '../date';
import { useTranslation } from 'react-i18next';
import VirtualizedTable from '../Table/VirtualizedTable';
export function DocumentImportStatusTable(_ref) {
  let {
    importStatuses,
    onDelete = null
  } = _ref;
  const {
    t
  } = useTranslation();
  const importTableHeaders = [{
    text: t('date')
  }, {
    text: t('uploaded_by')
  }, {
    text: ''
  }];
  const importTableRows = () => {
    return importStatuses?.filter(im => im.import_status !== 'never_imported').reverse().map(im => ({
      data: {
        id: im.id
      },
      key: im.id,
      columns: [createTimezonedDate(new Date(im.created_at), true).toCustomLocaleTimeString(), im.uploaded_by, /*#__PURE__*/React.createElement("a", {
        href: im.download_links?.url || im.download_link?.url,
        target: "_blank",
        rel: "noreferrer"
      }, im.download_links?.filename || im.download_link?.filename)]
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: '250px'
    }
  }, /*#__PURE__*/React.createElement(VirtualizedTable, {
    headers: importTableHeaders,
    rows: importTableRows(),
    onDelete: (rowIndex, row) => onDelete(row.data.id)
  }));
}